
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import VueGallery from 'vue-gallery';

import { Order } from '@/models/order';
import { FileType } from '@/models/file-type';
import { OrderComplainModel } from '@/models/order-complain';

import formatNumber from '@/shared/filters/format-number';
import utility from '@/utility/utility';
import { APP_CONFIG } from '../../../../../config/app-config';

@Component({
    components: {
        'gallery': VueGallery
    }
})
export default class DetailComplain extends Vue {
    private eventEmit = {
        eventChangeDataComplain: 'eventChangeDataComplain'
    };

    @Prop({default: null})
    private order!: Order;
    @Prop({default: null})
    private complain!: OrderComplainModel;

    private complainOptions = [
        { value: 1, name: 'Thiếu hàng', selected: false },
        { value: 2, name: 'Hàng bị hỏng', selected: false },
        { value: 3, name: 'Sai tùy chọn(Mẫu, size)', selected: false },
        { value: 4, name: 'Khác', selected: false }
    ];


    private complainValues = {
        indemnity: '',
        content: '',
        complainSelected: [] as any,
        images: [] as FileType[],
        noteForUser: ''
    };

    private index = null

    get imgs() {
        return this.complainValues.images.map(x => { return x.src; });
    }

    @Watch('complainValues', { immediate: true, deep: true })
    private onEmitDataComplain() {
        this.$emit(this.eventEmit.eventChangeDataComplain, this.complainValues);
    }

    @Watch('complain', { immediate: true, deep: true })
    private onComplainChange() {
        if (this.complain.id > 0) {
            this.complainOptions[0].selected = this.complain.isMissGood || false;
            this.complainOptions[1].selected = this.complain.isBroken || false;
            this.complainOptions[2].selected = this.complain.isOption || false;
            this.complainOptions[3].selected = this.complain.isOther || false;
            this.complainValues = {
                ...this.complainValues,
                indemnity: formatNumber(this.complain.amountNDT || 0, '0,0.[000000000000]'),
                content: this.complain.complainText,
                noteForUser: this.complain.noteForUser,
                images: (this.complain.img ? this.complain.img.split(';').map((v, i) => {
                    const item = new FileType();
                    item.id = i;
                    item.src = `${APP_CONFIG.settings.firebase_storage}/${APP_CONFIG.settings.firebase_prefix}%2Fcomplain%2F${v}?alt=media`
                    item.fileName = v;
                    return item;
                }) : null) || [],
                complainSelected: this.complainOptions.filter(x => x.selected === true)
            }
        }
    }

    onComplainOptChange(option: any) {
        this.complainOptions = this.complainOptions.map(co => {
            return {
                ...co,
                selected: co.value === option.value ? !co.selected : co.selected
            };
        });

        this.complainValues.complainSelected = this.complainOptions.filter(x => x.selected === true);
    }

    onChangeFile(event: any) {
        const onLoad = (file: any, id: number) => {
            const reader = new FileReader();
            reader.onload = e => {
                const arrFileType = file.name.split('.');
                this.complainValues.images.push({
                    fileName: `${this.order.id}_${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}` ,
                    src: reader.result || undefined,
                    file,
                    id
                });
            };
            reader.readAsDataURL(file);
        }

        if (event.target.files && event.target.files[0]) {
            let i = 1;
            const files = event.target.files;
            for (const file of files) {
                onLoad(file, i);
                i++;
            }
        }
    }

    onDeleteImage(id: number) {
        this.complainValues.images = this.complainValues.images.filter(x => x.id !== id);
        (this.$refs.fileInput as any).value = null;
    }
    
    showGallery(index: any) {
        this.index = index;
    }
}

